import React, { useRef, useEffect, useState } from 'react';
import MinimalSection from '../../components/MinimalSection';
import lingottiOro from '../../assets/lingotti/0082 - Still life Care is gold-Modifica.webp';
import lingottoKilo from '../../assets/lingotti/0020-Still-life-Care-is-gold-Modifica-2-Modifica-2.webp';
import mountainVideo from "../../assets/mouseFollow/Hero_5.mp4";
import logoTransp from '../../assets/mouseFollow/CIG_2601_Logo-03.png';
import logoFondazioneVeronesi from '../../assets/fondazioneVeronesi/CIG-2D+Fondazione-Bianco.png';
import logoVertocaleFondazioneVeronesi from '../../assets/fondazioneVeronesi/CIG-Verticale_2D+Fondazione-Blu.png';

import { SlArrowDown } from 'react-icons/sl';
import image1 from "../../assets/staticSection/family4.webp";
import image2 from "../../assets/staticSection/prodotto5.webp";
import reMida from "../../assets/libri/Book_Guerini_Scontorno.webp";
import FullMinimalSection from '../../components/FullMinimalSection';
import DefaultButton from '../../components/DefaultButton';
import fondazioneVeronesi from '../../assets/fondazioneVeronesi/Bimba-con-fiocco2.webp'
import { Helmet } from 'react-helmet';
import contattoUmano from '../../assets/consulenzaSupporto/contattoUmano.webp';
import contattoUmano2 from '../../assets/consulenzaSupporto/1crop.png';
import AOS from "aos";
import "aos/dist/aos.css";
import AccessibleVideo from '../../components/AccessibleVideo';

function HomePage() {
  const [width, setWidth] = useState(window.innerWidth);

  const nextSectionRef = useRef(null);

  var ogImage = 'https://www.careisgold.it/static/media/azienda_sede.ef12f4d81d9d70e63532.webp';

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  // Function to scroll to the next section
  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };


  // togliere aos transition per mini-screen
  useEffect(() => {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });

    const handleAosResize = () => {
      AOS.refreshHard();
    };

    window.addEventListener("resize", handleAosResize);

    return () => {
      window.removeEventListener("resize", handleAosResize);
    };
  }, []);


  return (
    <div className='relative'>
      {/* <SnowOverlay /> */}

      <Helmet>
        <title>Lingotti oro da investimento: prezzo e piani con Careisgold</title>
        <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
        <meta name="description" content="Scopri i vantaggi dell'investimento in Oro con Careisgold. Lingotti con sistema anticontraffazione. Soluzioni per la tutela del patrimonio alla portata di tutti." />
        <meta property="og:title" content="Careisgold SpA" />
        <meta property="og:description" content="Scopri i vantaggi dell'investimento in Oro con Careisgold. Lingotti con sistema anticontraffazione. Soluzioni per la tutela del patrimonio alla portata di tutti." />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content="https://www.careisgold.it/" />
        <meta property="og:type" content="page" />
        <meta name="keywords" content="investimento in oro, come investire in oro fisico, servizi di investimento in oro Careisgold, testimonianze reali investimento oro, benefici dell'oro come bene rifugio" />
        <meta name="author" content="Careisgold S.p.A" />
        <link rel="canonical" href="https://www.careisgold.it/" />
      </Helmet>

      <div className='relative z-20 h-lvh overflow-hidden'>
        <AccessibleVideo src={mountainVideo} className="absolute top-0 left-0 w-full h-full object-cover" style={{ transform: 'scale(1.2)' }} >
          <div className="absolute top-0 left-0 bg-opacity-0 w-full h-full flex justify-center mini-screen:backdrop-blur-sm">
            <img
              src={logoTransp}
              className='opacity-20 w-2/3 hidden lg:block'
              style={{ position: 'absolute', right: '-30vh', height: '150vh', objectFit: 'contain' }}
              alt='logo careisgold' />
            <div className="absolute bottom-0 left-0 text-left pb-56 px-8 md:p-32 mini-screen:pb-6 mini-screen:text-black text-white"
              data-aos="fade-up"
              data-aos-duration="3000">
              <h1 className="text-4xl md:text-7xl font-semibold drop-shadow-2xl mini-screen:text-xl">
                <span>L’oro accessibile a tutti,<br />prima di tutti</span>
                <span className='sr-only z-40 text-xs absolute top-[2%] text-white left-3/4 transform -translate-x-1/2'>
                  Careisgold: la prima azienda a rendere l’Oro da investimento accessibile a ogni famiglia.
                </span>
              </h1>
              <div className='text-justify'>
                <p className="text-md md:text-xl mt-4 drop-shadow-2xl">
                  <span className="text-md md:text-xl drop-shadow-2xl">Careisgold:{' '}</span>la prima azienda a rendere l’Oro da investimento<br />accessibile a ogni famiglia.</p>
              </div>
            </div>
            <SlArrowDown
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-duration="1000"
              onClick={scrollToNextSection}
              className='arrow cursor-pointer block absolute transform translate-x-1/2 text-slate-50 text-3xl md:text-5xl mini-screen:hidden' />
          </div>
        </AccessibleVideo>
      </div>

      <div ref={nextSectionRef}></div>
      <MinimalSection
        orientation='right'
        background='bg-black'
        title="La scelta responsabile per il tuo futuro"
        titleClass='text-4xl text-white mini-screen:text-xl'
        description={`
        Lingotti d'oro puro 24k certificati. Soluzioni personalizzate e servizi per la tutela del patrimonio a partire dal costo di una colazione al giorno.
        `}
        descriptionClass='font-medium py-9 text-xl text-neutral-300 mini-screen:text-base'
        buttonText='Perché l’Oro?'
        href='/investire-in-oro/'
        imageUrl={lingottiOro}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full lg:w-1/2'
        buttonClass2='w-full lg:w-1/2 mt-5'
        darkButton={true}
        secondButton={true}
        firstButtonText='Perché l’Oro?'
        secondButtonText='Lingotti'
        href2='/lingotti/'

      />
      <FullMinimalSection
        headerImage={width > 640 ? contattoUmano : contattoUmano2}
        logoTransp=''
        title='Per noi il contatto umano è fondamentale'
        description={`Non vendiamo online perché ci piace seguirti ancora come una volta. Con Careisgold avrai a disposizione un incaricato sempre
            pronto ad aiutarti in ogni fase del nostro percorso insieme. Inoltre, il nostro servizio clienti è sempre pronto ad offrirti supporto e assistenza.`}
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Scopri di più'
        screenReaderText='Consulenza e supporto'
        secondButton={false}
        secondButtonText=''
        href='/consulenza-supporto/'
        darkButton={true}
        buttonClass='w-full lg:w-1/2'
        buttonClass2='hidden'
        href2=''
        headingIdFirst="contatto-umano-heading"
        idFirstButton="consulenza-e-supporto"
        ariaLabelledbyFirst="consulenza-e-supporto contatto-umano-heading"
      />
      <MinimalSection
        orientation='left'
        background='bg-neutral-50 mini-screen:bg-black'
        title='Banco Metalli e Operatore Professionale in Oro'
        titleClass='text-4xl text-black mini-screen:text-white mini-screen:text-xl'
        description={`Careisgold è la società per azioni specializzata nel settore dell’Oro Puro Fisico da investimento. Iscritta nel registro OAM al nr. OPO6 come Operatore Professionale in Oro e Banco Metalli, Careisgold dispone della Licenza di Pubblica Sicurezza rilasciata dalla Questura per la distribuzione di Oro Puro Fisico da investimento.`}
        descriptionClass='text-bg-black font-normal tracking-wide text-pretty text-black text-xl pb-16 mini-screen:text-white mini-screen:pb-0'
        href='/azienda'
        imageUrl={lingottoKilo}
        imgOpacity="opacity-100"
        strength='0.14'
        lerp='0.30'
        buttonClass1='w-full lg:w-1/2'
        buttonClass2='hidden'
        darkButton={false}
        firstButtonText='Scopri cosa ci contraddistingue'
      />
      <FullMinimalSection
        headerImage={image1}
        logoTransp=''
        title='Ora puoi realizzare ciò che prima era impossibile'
        description={`Da sempre, l’Oro è stato un bene riservato ai ceti sociali più abbienti. Oggi, grazie agli innovativi prodotti creati da Careisgold, ogni italiano può acquistare lingotti d’oro puro con soluzioni studiate per ogni
        esigenza.`}
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Scopri di più'
        secondButtonText=''
        secondButton={false}
        href='/prodotti/'
        href2=''
        darkButton={true}
        buttonClass='w-full lg:w-1/2'
        buttonClass2='hidden'
        headingIdFirst="ora-puoi-realizzare-heading"
        idFirstButton="ora-puoi-realizzare-link"
        ariaLabelledbyFirst="ora-puoi-realizzare-heading"
      />
      {/* libri start */}
      {width < 640 ?
        <FullMinimalSection
          headerImage={reMida}
          logoTransp=''
          title='Il valore dell’oro per le famiglie italiane'
          description={`"Investire con Re Mida", curato dalla Prof.ssa Carolina Guerini, offre una guida chiara per comprendere il modo dell’oro da investimento con consapevolezza, attraverso dati, analisi e il case-history di Careisgold S.p.A.`}
          href='https://claudioboso.it/libri/'
          href2=''
          logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
          buttonText='Libro'
          secondButtonText=''
          secondButton={false}
          darkButton={true}
          buttonClass='w-full lg:w-1/2'
          buttonClass2='hidden'
        />
        :
        <MinimalSection
          orientation='left'
          background='bg-neutral-50'
          title='Il valore dell’oro per le famiglie italiane'
          titleClass='text-4xl text-black'
          description={`"Investire con Re Mida", curato dalla Prof.ssa Carolina Guerini, offre una guida chiara per comprendere il modo dell’oro da investimento con consapevolezza, attraverso dati, analisi e il case-history di Careisgold S.p.A.`}
          descriptionClass='text-bg-black font-normal tracking-wide text-pretty text-black text-xl pb-16'
          href='https://claudioboso.it/libri/'
          imageUrl={reMida}
          imgOpacity="opacity-100"
          strength='0.14'
          lerp='0.30'
          buttonClass1='w-full lg:w-1/2'
          buttonClass2='hidden'
          darkButton={false}
          firstButtonText='Libro'
        />
      }
      {/* novità e approfondimenti */}
      <FullMinimalSection
        headerImage={image2}
        logoTransp=''
        title='Novità e approfondimenti'
        description={`Per non perdere nessun aggiornamento sul mondo Careisgold e scoprire tante curiosità sul metallo
        prezioso per eccellenza, consulta la nostra rassegna stampa e tutti i nostri approfondimenti.`}
        href='/notizie'
        href2=''
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Esplora'
        secondButtonText=''
        secondButton={false}
        darkButton={true}
        buttonClass='w-full lg:w-1/2'
        buttonClass2='hidden'
      />

      {/* Fondazione Veronesi */}
      <section>
        <div className='relative mx-auto hidden lg:block'>
          <div className='h-lvh flex justify-center items-end sm:items-center relative'>
            {/* Left Content Section */}
            <div className={`absolute top-0 left-0 h-full w-full 2xl:w-3/5 bg-transparent flex flex-col items-start md:pl-20 justify-center p-4 z-0`}>
              <img src={logoFondazioneVeronesi} alt='logo careisgold sostiene fondazione veronesi' className='-mt-5 w-1/2 2xl:w-full z-50' />
              <div className='text-left max-w-xl lg:max-w-xl xl:max-w-xl'>
                <div className='flex xl:flex-row flex-col items-start xl:items-start xl:justify-around'>
                </div>
                <h2 id='fondazione-veronesi-heading' className={`font-semibold text-2xl text-neutral-50 text-balance my-10`} data-aos="fade-up" data-aos-duration="900">
                  Careisgold sostiene Fondazione Veronesi
                  <span className='ms-2'>nella lotta contro i tumori infantili</span>
                </h2>
                <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-xl mb-10 text-neutral-300 text-balance`}>
                  <b>Prendersi cura</b> delle persone è il fulcro dell'azienda, il nostro impegno ci ha portato a realizzare un nuovo progetto, che vuole mettere al centro i bambini malati di tumore.
                </div>
                <DefaultButton
                  text='Scopri di più'
                  link='https://beneficenza.careisgold.it/fondazione-veronesi'
                  id='sostieni-fondazione-veronesi'
                  dark={true}
                  buttonClass='w-full'
                  ariaLabelledby='sostieni-fondazione-veronesi fondazione-veronesi-heading'
                />
              </div>
            </div>

            {/* Right Background Section */}
            <div className={`absolute top-0 right-0 h-full w-full lg:w-1/4 bg-white`}>
            </div>

            {/* Image Section */}
            <div className='absolute sm:h-full right-0 w-2/5 overflow-hidden'>
              <img
                src={fondazioneVeronesi}
                alt='fondazione veronesi'
                className='h-full w-[100%] ms-auto object-left-top object-cover z-20'
              />
            </div>
          </div>
        </div>
        <div className={`top-0 right-0 h-full w-full lg:w-1/4 bg-white lg:hidden block md:px-[10rem] md:pt-10 px-5 `}>
          <div className='z-20 relative top-0 px-5 flex md:flex-row flex-col md:pb-5'>
            <img src={logoVertocaleFondazioneVeronesi} alt='logo careisgold sostiene fondazione veronesi' className='object-contain  mx-auto md:px-2 md:-mt-[2rem] pt-5' />
          </div>
          <DefaultButton text='Scopri di più' link='https://beneficenza.careisgold.it/fondazione-veronesi' dark={false} buttonClass='w-full mt-5' />
          <img src={fondazioneVeronesi} alt='fondazione veronesi' className='left-0 object-contain z-20' />
        </div>
      </section>
      {/* <Modal isVisible={isModalVisible} onClose={() => setModalVisible(false)} /> */}

    </div>
  )
}

export default HomePage